import { useEffect, useState } from 'react'
import { getPlans } from '../../../services/Plan';
import Cross from '../../../icons/Cross';
import Loading from '../../../icons/Loading';
import colorConfigs from '../../../configs/colorConfigs';
import { useTheme } from '../../../components/hooks/useTheme';
import { Dialog } from '@mui/material';
import useTenant from '../../../components/hooks/useTenant';

type UpgradeSubscriptionProps = {
  showPopupUpgradeSubscription: boolean;
  setShowPopupUpgradeSubscription: (value: boolean) => void;
  planDetails: any;
  setShowPopupForPayment: (Value: boolean) => void;
  setUpgradePlan: (value: any) => void;
  activePaymentDetails: any | null;
  isProcessing: boolean;
  setIsProcessing: (value: boolean) => void;
  callTheAPIForUpgradeSubscription: (upgradedPlan: any, activePaymentDetails: any, cb: any) => void;
}

const UpgradeSubscription = ({
  showPopupUpgradeSubscription,
  setShowPopupUpgradeSubscription,
  planDetails,
  setShowPopupForPayment,
  setUpgradePlan,
  activePaymentDetails,
  isProcessing,
  setIsProcessing,
  callTheAPIForUpgradeSubscription
}: UpgradeSubscriptionProps) => {
  const [plans, setPlans] = useState<any>([]);
  const [plansDataIsLoaded, setPlansDataIsLoaded] = useState<boolean>(false);
  const [filterPlans, setFilterPlans] = useState<any>([]);
  const { themeStyles, theme } = useTheme();
  const { handleTenantError }: any = useTenant();

  const textColor =
    theme === "dark"
      ? `${themeStyles.main.textSubHeadingColor}`
      : `${themeStyles.main.textHeadingColor}`;

  useEffect(() => {
    getPlans()
      .then(res => {
        setPlans(res.reverse());
        setPlansDataIsLoaded(true);
        handleTenantError(null);
      })
      .catch(error => {
        handleTenantError(error);
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (plansDataIsLoaded && planDetails !== null) {
      let updateFilteredPlans = [];

      if (planDetails?.planName?.toLowerCase()?.includes('standard')) {
        if (planDetails?.billingCycle?.toLowerCase() === 'month') {
          updateFilteredPlans = plans?.filter((plan: any) => !(plan?.planName?.toLowerCase()?.includes('standard') && plan?.billingCycle?.toLowerCase() === 'month'));
        } else {
          updateFilteredPlans = plans?.filter((plan: any) => !plan?.planName?.toLowerCase()?.includes('standard'));
        }
      } else {
        if (planDetails?.billingCycle?.toLowerCase() === 'month') {
          updateFilteredPlans = plans?.filter((plan: any) => plan?.planName?.toLowerCase()?.includes('premium') && plan?.billingCycle?.toLowerCase() === 'year');
        } else {
          updateFilteredPlans = [];
        }
      }

      setFilterPlans(updateFilteredPlans);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [plansDataIsLoaded, planDetails, plans]);

  const closeModal = () => {
    setShowPopupUpgradeSubscription(false);
  }

  const upgradePlan = (value: any) => {
    setUpgradePlan(value);
    if (activePaymentDetails === null) {
      setShowPopupForPayment(true);
      closeModal();
    } else {
      if (!isProcessing) {
        setIsProcessing(true);

        callTheAPIForUpgradeSubscription(value, activePaymentDetails, () => {
          closeModal();
        });
      }
    }
  }

  return (
    <Dialog
      open={showPopupUpgradeSubscription}
      sx={{
        '& .MuiDialog-paper': {
          maxWidth: '800px',
          width: '100%',
          borderRadius: '16px',
        },
      }}
    >
      <div className={`fixed inset-0 p-4 mt-16 flex flex-wrap justify-center items-center w-full z-50 overflow-auto ${showPopupUpgradeSubscription ? 'flex' : 'hidden'}`}>
        <div className={`w-full max-w-[32rem] shadow-lg rounded-lg relative ${themeStyles.main.tailwindMainBg}`}>
          <div className={`text-white bg-[#167AC3] px-4 py-2 w-full h-[40px] flex justify-between items-center rounded-t-lg`}>
            <h4 style={{ fontWeight: "500" }}>Subscription Plan</h4>
            {!isProcessing && <Cross closeModal={closeModal} />}
          </div>

          <div className="flex flex-col p-4 gap-3">
            <div className="flex gap-2 items-center">
              <h5 className={`font-medium ${textColor}`}>
                Current Plan:
              </h5>

              <p className={`p-0 font-normal text-sm ${textColor}`}>
                {planDetails?.planName}
                \<span className="capitalize">{planDetails?.billingCycle}</span>
              </p>
            </div>

            {
              filterPlans?.map((plan: any, index: number) => (
                <div
                  key={index}
                  className={`flex gap-2 justify-between items-center border-b py-0.5 ${themeStyles.main.borderColor}`}
                >
                  <div className="flex items-center gap-x-[0.25rem]">
                    <h5 className={`font-medium ${textColor}`}>
                      {plan?.planName}
                      \<span className="capitalize">{plan?.billingCycle}:</span>
                    </h5>

                    <p className={`font-normal ${textColor}`}>${plan?.price}</p>
                  </div>

                  {
                    isProcessing
                      ? (
                        <button
                          type="button"
                          style={{
                            backgroundColor: colorConfigs.primaryColor,
                          }}
                          className="rounded-md py-1 px-3 font-medium text-white"
                        >
                          <Loading />
                        </button>
                      ) : (
                        <button
                          className="bg-[#167AC3] rounded-md py-1 px-3 font-medium text-white cursor-pointer"
                          onClick={() => upgradePlan(plan)}
                        >
                          Upgrade
                        </button>
                      )
                  }
                </div>
              ))
            }
          </div>
        </div>
      </div>
    </Dialog>
  );
}

export default UpgradeSubscription;